// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0DF0y","childrenWrapper":"styles_childrenWrapper__aTTV8"};